import { useConfigStore } from '../feature-flags/useConfigStore'
import { z } from 'zod'

const userSettingsSchema = z.object({
  position: z
    .union([z.literal('off'), z.literal('footer'), z.literal('navbar')])
    .default('off')
    .transform((value) => {
      if (value === 'navbar') return 'footer'
      return value
    }),
  defaultSettings: z.object({
    theme: z.union([z.literal('light'), z.literal('dark'), z.literal('auto')]),
    articleSummary: z.boolean().default(true),
  }),
  enabledSettings: z
    .object({
      articleSummary: z.boolean().default(false),
    })
    .default({ articleSummary: false }),
})

export const siteSettingsSchema = z.object({
  userSettings: z.optional(userSettingsSchema),
  enableLocalNewsSearch: z.optional(z.boolean()).default(true),
  sortNewsBy: z
    .optional(z.union([z.literal('publishedDate'), z.literal('clusterSize')]))
    .default('publishedDate'),
  enableArticleReordering: z.optional(z.boolean()),
  videoEnabled: z.optional(z.boolean()),
})

export type SiteSettings = z.infer<typeof siteSettingsSchema>

export const useSiteSettingsStore = useConfigStore({
  defaults: siteSettingsSchema.parse({
    userSettings: {
      position: 'off',
      defaultSettings: {
        theme: 'light',
        articleSummary: true,
      },
      enabledSettings: {
        articleSummary: false,
      },
    },
    enableLocalNewsSearch: true,
    sortNewsBy: 'clusterSize',
    enableArticleReordering: false,
    videoEnabled: false,
  }),
  configStoreKey: 'siteSettings',
  schema: (data) => siteSettingsSchema.parse(data),
})
